import { render, staticRenderFns } from "./ResizeEvent.vue?vue&type=template&id=119b3df6&scoped=true&"
import script from "./ResizeEvent.vue?vue&type=script&lang=ts&"
export * from "./ResizeEvent.vue?vue&type=script&lang=ts&"
import style0 from "./ResizeEvent.vue?vue&type=style&index=0&id=119b3df6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119b3df6",
  null
  
)

export default component.exports